import { type ChannelDTO, type ConversationDTO, DM_RETENTION_DAYS, type MeDTO, type UserDTO } from "@justone/shared";
import type { RoomRef } from "../api/queries";

/** 메시지 목록·입력창·스레드 창이 공통으로 쓰는 방 정보 */
export interface RoomView {
  ref: RoomRef;
  /** "#일반" 또는 "민수, 지수" */
  title: string;
  /** 본문 맨 위 소개 */
  intro: string;
  placeholder: string;
  /** 답글을 본문에도 보내는 체크박스 라벨 */
  alsoLabel: string;
  lastReadMessageId: number | null;
  unread: number;
  /** 읽음 위치를 기록하는 방인지 (참여하지 않은 채널은 기록하지 않음) */
  tracksRead: boolean;
  canWrite: boolean;
}

export function channelView(c: ChannelDTO, me: MeDTO): RoomView {
  return {
    ref: { kind: "channel", id: c.id },
    title: `#${c.name}`,
    intro: c.topic || `#${c.name} 채널의 처음입니다.`,
    placeholder: `#${c.name}에 메시지 보내기`,
    alsoLabel: `#${c.name}에도 보내기`,
    lastReadMessageId: c.lastReadMessageId,
    unread: c.unread,
    tracksRead: c.joined,
    canWrite: c.joined && (!c.archived || me.role === "admin"),
  };
}

/** 대화 상대 이름 (나를 뺀 사람들) */
export function dmTitle(c: Pick<ConversationDTO, "memberIds">, users: Map<number, UserDTO>, meId: number): string {
  const others = c.memberIds.filter((id) => id !== meId);
  if (others.length === 0) return "나";
  return others.map((id) => users.get(id)?.displayName ?? "알 수 없음").join(", ");
}

export function dmView(c: ConversationDTO, users: Map<number, UserDTO>, me: MeDTO): RoomView {
  const title = dmTitle(c, users, me.id);
  return {
    ref: { kind: "dm", id: c.id },
    title,
    intro: `${title}님과의 대화입니다. 메시지는 ${DM_RETENTION_DAYS}일 후 사라집니다.`,
    placeholder: `${title}에게 메시지 보내기`,
    alsoLabel: "대화에도 보내기",
    lastReadMessageId: c.lastReadMessageId,
    unread: c.unread,
    tracksRead: true,
    canWrite: true,
  };
}
